import { useI18n } from '@/hooks/useI18n';

export const Footer = () => {
  const { t } = useI18n();

  return (
    <footer className="footer">
      <div className="footer-copy">
        <span>
          <strong>{t('brand.name')}</strong> · {t('brand.tagline')}
        </span>
        <span className="footer-rights">{t('footer.rights', { year: new Date().getFullYear() })}</span>
      </div>
    </footer>
  );
};
